type LorebookHit = {
  id?: string;
};

type FilterFavoriteLorebookHitsProps<Hit extends LorebookHit> = {
  hits: Hit[];
  isFavoritesLorebooksPage: boolean;
  likedLorebookIds: string[];
  pendingRemovedLorebookIds: Set<string>;
};

const filterFavoriteLorebookHits = <Hit extends LorebookHit>({
  hits,
  isFavoritesLorebooksPage,
  likedLorebookIds,
  pendingRemovedLorebookIds,
}: FilterFavoriteLorebookHitsProps<Hit>): Hit[] => {
  if (!isFavoritesLorebooksPage) {
    return hits;
  }

  const likedLorebookIdSet = new Set(likedLorebookIds);
  return hits.filter((hit) => {
    const lorebookId = hit.id;
    return !!lorebookId && likedLorebookIdSet.has(lorebookId) && !pendingRemovedLorebookIds.has(lorebookId);
  });
};

export default filterFavoriteLorebookHits;
